export default __webpack_public_path__ + "static/media/013-get up early.d763f776.svg";